import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPartnerInquiries = lazy(() => import("@/pages/admin/AdminPartnerInquiries"));

export const Route = createFileRoute("/admin/partnerships")({
  component: AdminPartnerInquiries,
});
